import { useContext } from 'react'
import { ConfigContext, useTranslation } from '../../../context/ConfigContext'
import { gtmCategory, gtmPush } from '../../../utils/gtmHelpers'
import { useIsMobileOrTablet } from '../../../utils/screen.utils'
import { ProductConfigurationMaybeOnStore } from './ProductConfigurationCta.utils'

const OrderByPhoneCta = ({ product }: { product: Product }) => {
  const t = useTranslation()

  const { storeConfig } = useContext(ConfigContext)
  const tel = storeConfig.general_store_information_phone?.replace(/\s/g, '')

  const handleClick = () => {
    const storedValues = JSON.parse(window.localStorage.getItem('productValues') as any)
    const gtmCategoryObj = gtmCategory(product.gtm_categories)

    gtmPush({
      event: 'order_by_phone',
      ecommerce: {
        currency: product?.price_range?.minimum_price?.regular_price?.currency,
        value: product?.price_range?.minimum_price?.regular_price?.value,
        items: [
          {
            item_name: product?.gtm_name,
            item_id: product?.sku,
            price: product?.price_range.minimum_price.regular_price.value,
            item_brand: 'Messika',
            item_list_id: storedValues ? storedValues.listId : 'produit',
            item_list_name: storedValues ? storedValues.listName : 'Produit',
            index: storedValues?.position ?? '',
            item_variant: product?.sku,
            ...gtmCategoryObj,
          },
        ],
      },
    })
  }

  const isTablet = useIsMobileOrTablet()
  if (isTablet) {
    return (
      <>
        <ProductConfigurationMaybeOnStore />
        <a href={`tel:${tel}`} className='button black' onClick={handleClick}>
          {t('Contact us', {}, false)}
        </a>
      </>
    )
  }

  return (
    <>
      <a href={`tel:${tel}`} className='button black' onClick={handleClick}>
        {t('Contact us', {}, false)}
      </a>
      <ProductConfigurationMaybeOnStore />
    </>
  )
}

export default OrderByPhoneCta
